import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon3D } from "@/components/ui/icon-3d";
import { cn } from "@/lib/utils";

export function MobileBottomNav() {
  const location = useLocation();

  const items = [
    { href: "/app", label: "Home", icon: "home" },
    { href: "/app/proof-packs", label: "Proofs", icon: "file-check" },
    { href: "/app/triggers", label: "Alerts", icon: "bell" },
    { href: "/app/settings", label: "Settings", icon: "settings" },
  ];

  return (
    <nav aria-label="mobile bottom navigation" className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border bg-background">
      <div className="mx-auto max-w-[1400px] px-4">
        <div className="flex justify-around py-2">
          {items.map((it) => (
            <Link
              key={it.href}
              to={it.href}
              className={cn(
                "flex flex-col items-center justify-center touch-target text-xs text-muted-foreground",
                location.pathname === it.href ? "text-foreground" : ""
              )}
            >
              <Icon3D name={it.icon} size="sm" />
              <span className="mt-1 text-[11px]">{it.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default MobileBottomNav;
